const API_VERSION = 3;
const baseUrl = `/api/jobsearch/v${API_VERSION}/`;

function _parseParams(params) {
    const out = [];
    Object.entries(params).forEach(([parameter, value]) => {
        if (Array.isArray(value)) {
            value.forEach(element => out.push([parameter, element]));
        } else {
            if (value) {
                out.push([parameter, value]);
            }
        }
    });
    return out;
}

function api(endpoint, params = {}, options = {}) {
    const method = 'GET';
    const path = Array.isArray(endpoint) ? endpoint.join("/") : endpoint;
    const url = path.startsWith('/') ? path : baseUrl + path;
    const urlSearchParams = new URLSearchParams(_parseParams(params));
    const fullUrl = url + '?' + urlSearchParams.toString();

    const mergedOtions = {
        method,
        ...options,
    };

    if (window.Stash && window.Stash.common && window.Stash.common.csrf_token) {
        mergedOtions.headers = {
            ...(mergedOtions.headers ?? {}),
            "X-CSRF-Token": window.Stash.common.csrf_token,
        };
    }

    return fetch(fullUrl, mergedOtions).catch(e => {
        // If it's a DOMException we assume it's an AbortError
        // and at the time of writing we cannot properly check it further
        // since the only two options for checking is either deprecated or experimental.
        // The two options would, once it's established that e is an instance of DOMException,
        // be e.code === 20 (deprecated) or e.name === 'AbortError' (experimental).
        if (!(e instanceof DOMException)) {
            throw e;
        } else {
            return { ok: false, };
        }
    });
}


export function search(params = {}, options = {}) {
    return api([], params, options);
}

export function searchAnalysis(params = {}, options = {}) {
    return api(['analysis'], params, options);
}

export function searchMap(params = {}, options = {}) {
    return api(['map'], params, options);
}

export function searchUnsolicited(params = {}, options = {}) {
    return api(['unsolicited'], params, options);
}

export function hitcount(params = {}, options = {}) {
    return api(['jobcount'], params, options);
}
